import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AndroidPlaceholder = ({ height = 13, width = 13, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 13 13" {...props}>
    <circle
      xmlns="http://www.w3.org/2000/svg"
      opacity="0.5"
      cx="6.5"
      cy="6.5"
      r="6.5"
      fill="#B56DC6"
    />
  </SvgIcon>
);
